import React, { Component } from "react";

class Section2Mobile extends Component {
  state = {
    translateRight: 0,
    translateLeft: 0,
    translateRightPropertie: 0,
    translateLeftPropertie: 0,
    rightOpacity: 0,
  };
  componentDidMount() {
    this.setState({
      translateRight: -this.props.wd.sh * 0.7,
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.pagescrolled !== prevProps.pagescrolled) {
      var st = this.props.pagescrolled;
      this.scrollAnimations(st);
    }
  }
  scrollAnimations = (scroll) => {
    var ele_left = document.querySelector("#section2 .column.left");
    var ele_right = document.querySelector("#section2 .column.right");

    var TranslateRight;
    var TranslateRightPropertie;
    var TranslateLeft;
    var TranslateLeftPropertie;
    var RightOpacity;
    var startAnimFactor = 0.3 * this.props.wd.wh;

    var ele_offsettop_left = ele_left.offsetTop;
    var ele_offsettop_right = ele_right.offsetTop;
    /*** set opacity Animation */
    var sectionScrollPercentageWithFactor =
      (100 * (scroll - (ele_offsettop_right - startAnimFactor))) /
      ele_right.clientHeight;
    if (scroll > ele_offsettop_right - startAnimFactor) {
      RightOpacity =
        sectionScrollPercentageWithFactor * 0.05 < 1
          ? sectionScrollPercentageWithFactor * 0.05
          : 1;
    } else {
      RightOpacity = 0;
    }

    this.setState({
      rightOpacity: RightOpacity,
    });
    /*** set translate right Animation */
    TranslateLeft = this.state.translateLeft + (scroll - ele_offsettop_left);
    TranslateLeftPropertie = "translate3d(0px," + TranslateLeft + "px, 0px)";

    if (TranslateLeft > 0) {
      TranslateLeftPropertie = "translate3d(0px, 0px, 0px)";
    } else {
      TranslateLeftPropertie = "translate3d(0px," + TranslateLeft + "px, 0px)";
    }
    this.setState({ translateLeftPropertie: TranslateLeftPropertie });
    /*** set translate left Animation */
    TranslateRight = this.state.translateRight + (scroll - ele_offsettop_right);

    if (TranslateRight >= 0) {
      TranslateRightPropertie =
        "translate3d(0px," + TranslateRight + "px, 0px)";
    } else {
      TranslateRightPropertie = "translate3d(0px, 0px, 0px)";
    }
    this.setState({ translateRightPropertie: TranslateRightPropertie });
  };
  render() {
    return (
      <div
        id="section2"
        className="section content_container"
        style={{
          width: this.props.wd.ww,
          height: this.props.wd.sh,
        }}
      >
        <div
          className="column left"
          style={{
            backgroundColor: `rgba(0, 0, 0, 1)`,
          }}
        >
          <div className="content">
            <img
              alt="Título Jiu Jitsu"
              className="title title_lg transitionY_animation"
              src="images/section2_whitetitle.png"
              style={{
                transform: this.state.translateLeftPropertie,
              }}
            />
            <img
              alt="Subítulo Jiu Jitsu"
              className="subtitle"
              src="images/section2_whitesubtitle.png"
            />
            <p>
              O jiu jitsu é uma arte marcial originalmente utilizada nas
              guerras, onde o guerreiro usa a sua força através de golpes que
              envolvem as articulações, estrangulamentos, imobilizações, torções
              e alavancas no corpo do adversário.
              <br /> No Brasil ganhou um estilo específico, conhecido como
              Brazilian Jiu Jitsu, um desporto de combate, de luta e de
              autodefesa.
            </p>
          </div>
        </div>
        <div
          className="column right"
          style={{ backgroundImage: "url(images/section2_background1.jpg)" }}
        >
          <div
            className="backgroundImage opacity_animation"
            style={{
              backgroundImage: "url(images/section2_background2.jpg)",
              opacity: this.state.rightOpacity,
            }}
          ></div>
          <div className="content">
            <img
              alt="Título Xadrez Humano"
              className="title title_lg transitionY_animation"
              src="images/section2_blacktitle.png"
            />
            <p
              className="transitionY_animation"
              style={{ transform: this.state.translateRightPropertie }}
            >
              Etimologicamente, a expressão japonesa jiu jitsu pode ser
              traduzida literalmente como “arte da suavidade” ou “técnica da
              brandura”, uma referência ao caráter e filosofia desta arte
              marcial: o equilíbrio e o controle total do corpo. O Jiu Jitsu
              aumenta a confiança, ajuda a emagrecer, reduz o stress, melhora a
              coordenação motora e trabalha o corpo de forma completa.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Section2Mobile;
